const index = (arr, id) => arr.findIndex((item) => item.id === id)

export default {
	namespaced: true,
	state: {
		confirm: {
			visible: false,
			labels: {
				text: '',
				success: ''
			},
			action: ''
		},
		box: []
	},
	getters: {
		confirm: ({ confirm }) => confirm.visible,
		labelsConfirm: ({ confirm }) => confirm.labels,
		actionConfirm: ({ confirm }) => confirm.action,

		box: ({ box }) => box
	},
	mutations: {
		confirm({ confirm }, { labels, action }) {
			confirm.visible = true
			confirm.labels = labels
			confirm.action = action
		},
		resetConfirm(state) {
			state.confirm = {
				visible: false,
				labels: {
					text: '',
					success: ''
				},
				action: ''
			}
		},
		box({ box }, payload) {
			box.push({
				...payload,
				id: box.length
			})
		},
		removeBox({ box }, id) {
			box.splice(index(box, id), 1)
		}
	},
	actions: {
		confirm: ({ commit }, obj) => commit('confirm', obj),
		resetConfirm: ({ commit }) => commit('resetConfirm'),

		box: ({ commit }, obj) => commit('box', obj),
		removeBox: ({ commit }, id) => commit('removeBox', id)
	}
}
